import { map, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { DictTimezoneAction } from '../dictTimezone.action';

type IDependencies = IClientApiDependencySegment;

export const loadTimezonesEpic: IEpic<{}, IDependencies> = (action$, _, { api }) => action$.pipe(
  isTypeOf(DictTimezoneAction.loadList.started),
  mergeMap(() =>
    api.getDictTimezones().pipe(
      map(({ timezones }) => DictTimezoneAction.loadList.done({ params: undefined, result: timezones })),
      catchApiError((error) => [
        DictTimezoneAction.loadList.failed({ params: undefined, error }),
        createApiErrorNotification(error),
      ]),
    ),
  ),
);
